
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase'
    import Enums from '@/lib/enums'
    import { GetPrintWorld } from '@/common/js/PrintWorld'
    import UpdateOderStatu from './update-stockorder-status.vue'
    import UpdatebackstockorderStatu from '@/store/entities/back-updatestatus'
    import moment from 'moment'
    import appconst from '@/lib/appconst';

    // 扫描记录接口
    interface ScanRecord {
        id: string;
        productId: number;
        productNo: string;
        productSku: string;
        productName: string;
        scanCount: number;
        lastScanTime: string;
        productImgGuid: string;
    }

    // 当前订单接口
    interface CurrentOrder {
        orderId: number;
        orderNumber: string;
        sort: number;
        products: any[];
        sameProductCount: number;
        totalProductCount: number;
        remainingCount: number;
        totalRemainingAll: number;
        currentProductNeedCount: number;
        currentProductScannedCount: number;
        sortPriority: number;
        priorityText: string;
    }

    @Component({
        name: "backstockorderbatchpackbybox",
        components: { UpdateOderStatu }
    })
    export default class BackStockBatchPackByBox extends AbpBase {
        // 路由参数
        batchId: number = 0;
        batchNumber: string = '';

        // 统计数据
        totalCount: number = 0;
        packedCount: number = 0;
        unpackedCount: number = 0;

        // 扫描相关
        scanBarcode: string = '';
        scanRecords: ScanRecord[] = [];
        currentOrder: CurrentOrder | null = null;   // 当前订单（箱号最小的可打包订单）


        // 扫描防抖
        lastScanBarcode: string = '';
        lastScanTime: number = 0;
        scanLock: boolean = false; // 加这个锁
        
        // 订单列表
        orderList: any[] = [];
        loading: boolean = false;

        // 打印相关
        isPdfData: boolean = true;
        needCert: boolean = true;
        automaticJump: boolean = false;
        printerList: string[] = [];
        selectedPrinter: string = '';
        isLoadPrintList: boolean = false;

        // 异常弹窗
        updateOderStatuShow: boolean = false;
        currentAbnormalOrder: any = null;

        // 扫描表格列
        scanColumns = [
            {
                title: '商品编码',
                key: 'productNo',
                width: 200
            },
            {
                title: '产品内码',
                key: 'productId',
                width: 100
            },
            {
                title: 'Sku信息',
                key: 'productSku',
                minWidth: 100
            },
            {
                title: '商品图片',
                width: 80,
                align: 'center',
                render: (h: any, params: any) => {
                    let imgUrl = '';
                    const product = params.row;
                    if (product && product.productImgGuid) {
                        if (product.productImgGuid.indexOf('http') === 0 || product.productImgGuid.indexOf('https') === 0) {
                            imgUrl = product.productImgGuid;
                        } else {
                            const data = { imageGuid: product.productImgGuid, url: null };
                            this.$store.commit('expressuserinfo/getImgUrl', data);
                            imgUrl = data.url;
                        }
                    }

                    return h('div', {
                        style: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }
                    }, [
                        imgUrl ? h('img', {
                            style: {
                                width: '40px',
                                height: '40px',
                                objectFit: 'cover',
                                border: '1px solid #f0f0f0',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            },
                            attrs: {
                                src: imgUrl,
                                preview: 'scan_' + params.row.productId,
                                'preview-text': params.row.productNo || params.row.productSku
                            }
                        }) : h('div', {
                            style: {
                                width: '40px',
                                height: '40px',
                                background: '#f5f5f5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#999',
                                fontSize: '12px',
                                border: '1px solid #f0f0f0',
                                borderRadius: '4px'
                            }
                        }, '无图')
                    ]);
                }
            },
            {
                title: '扫描数量',
                key: 'scanCount',
                width: 200,
                render: (h: any, params: any) => {
                    return h('div', [
                        h('InputNumber', {
                            props: {
                                value: params.row.scanCount,
                                min: 0,
                                size: 'small'
                            },
                            style: {
                                width: '80px',
                                marginRight: '5px'
                            },
                            on: {
                                'on-change': (value: number) => {
                                    this.updateScanCount(params.row, value);
                                }
                            }
                        }),
                        h('Button', {
                            props: {
                                type: 'error',
                                size: 'small',
                                icon: 'md-trash'
                            },
                            style: {
                                marginLeft: '5px'
                            },
                            on: {
                                click: () => {
                                    this.deleteScanRecord(params.row);
                                }
                            }
                        })
                    ]);
                }
            },
            {
                title: '最后扫描时间',
                key: 'lastScanTime',
                width: 160,
                render: (h: any, params: any) => {
                    return h('span', moment(params.row.lastScanTime).format('YYYY-MM-DD HH:mm:ss'));
                }
            }
        ];

        // 当前订单表格列
        currentOrderColumns = [
            {
                title: '箱号',
                key: 'sort',
                width: 100,
                render: (h: any, params: any) => {
                    return h('Tag', {
                        props: { color: 'primary' }
                    }, params.row.sort || '-');
                }
            },
            {
                title: '订单编号',
                key: 'orderNumber',
                width: 180,
                fixed: 'left'
            },
            {
                title: '商品信息',
                minWidth: 400,
                render: (h: any, params: any) => {
                    return h('div', [
                        h('ul', {
                            style: {
                                listStyle: 'none',
                                margin: 0,
                                padding: 0
                            }
                        }, params.row.products.map((item: any) => {
                            const itemStyle = {
                                fontSize: '12px',
                                lineHeight: '28px',
                                borderBottom: '1px dashed #e8e8e8',
                                padding: '0 5px',
                                backgroundColor: item.isScanned ? '#f0f9eb' : 'transparent',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            };

                            return h('li', {
                                style: itemStyle,
                                attrs: {
                                    title: `${item.productNo || ''} 内码:${item.productId} 数量:${item.scannedCount}/${item.needCount}${item.shelfPosition ? ' 货架:' + item.shelfPosition : ''}`
                                }
                            }, [
                                item.productNo ? h('span', item.productNo + ' ') : null,
                                h('span', {
                                    style: {
                                        color: '#ed4014',
                                        fontWeight: 'bold'
                                    }
                                }, `[${item.productId}]`),
                                h('span', {
                                    style: {
                                        marginLeft: '8px',
                                        color: item.isScanned ? (item.remaining === 0 ? '#19be6b' : '#ed4014') : '#666'
                                    }
                                }, `${item.scannedCount}/${item.needCount}`),
                                item.shelfPosition ? h('span', {
                                    style: {
                                        marginLeft: '8px',
                                        color: '#2d8cf0'
                                    }
                                }, `货:${item.shelfPosition}`) : null
                            ]);
                        }))
                    ]);
                }
            },
            {
                title: '匹配信息',
                width: 200,
                render: (h: any, params: any) => {
                    return h('div', [
                        h('Tag', {
                            props: {
                                color: params.row.sortPriority <= 1 ? 'success' : (params.row.sortPriority === 2 ? 'warning' : 'primary')
                            }
                        }, params.row.priorityText),
                        h('div', {
                            style: {
                                marginTop: '4px',
                                fontSize: '12px'
                            }
                        }, `剩余:${params.row.totalRemainingAll}`)
                    ]);
                }
            }
        ];

        // 订单表格列（增加箱号字段）
        get orderColumnsWithBox() {
            return [
                {
                    title: '箱号',
                    key: 'sort',
                    width: 100,
                    render: (h: any, params: any) => {
                        return h('span', params.row.sort !== undefined && params.row.sort !== null ? params.row.sort : '-');
                    }
                },
                {
                    title: '订单编号',
                    key: 'orderNumber',
                    width: 170,
                },
                {
                    title: '运单号',
                    key: 'tradeNo',
                    width: 150
                },
                {
                    title: '产品信息',
                    minWidth: 400,
                    render: (h: any, params: any) => {
                        return h('div', [
                            h('ul', params.row.productInfos.map((item: any) => {
                                const scanned = this.getProductScannedCount(item.productId);
                                const isComplete = scanned >= item.count;

                                let imgUrl = '';
                                if (item.productImgGuid) {
                                    if (item.productImgGuid.indexOf('http') === 0 || item.productImgGuid.indexOf('https') === 0) {
                                        imgUrl = item.productImgGuid;
                                    } else {
                                        const data = { imageGuid: item.productImgGuid, url: null };
                                        this.$store.commit('expressuserinfo/getImgUrl', data);
                                        imgUrl = data.url;
                                    }
                                }

                                return h('li', {
                                    style: {
                                        fontSize: '12px',
                                        lineHeight: '30px',
                                        borderBottom: '1px dashed #e8e8e8',
                                        padding: '5px 0',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }
                                }, [
                                    imgUrl ? h('img', {
                                        style: {
                                            width: '40px',
                                            height: '40px',
                                            marginRight: '10px',
                                            objectFit: 'cover',
                                            border: '1px solid #f0f0f0',
                                            borderRadius: '4px'
                                        },
                                        attrs: {
                                            src: imgUrl,
                                            preview: 'product_' + item.productId,
                                            'preview-text': item.productNo || item.productSku
                                        },
                                        on: {
                                            click: (e: any) => {
                                                e.stopPropagation();
                                            }
                                        }
                                    }) : h('div', {
                                        style: {
                                            width: '40px',
                                            height: '40px',
                                            marginRight: '10px',
                                            background: '#f5f5f5',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#999',
                                            fontSize: '12px',
                                            border: '1px solid #f0f0f0',
                                            borderRadius: '4px'
                                        }
                                    }, '无图'),

                                    h('div', {
                                        style: {
                                            flex: 1
                                        }
                                    }, [
                                        h('div', {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginBottom: '2px',
                                                flexWrap: 'wrap'
                                            }
                                        }, [
                                            h('span', {
                                                style: {
                                                    fontWeight: 'bold',
                                                    marginRight: '15px',
                                                    color: '#333'
                                                }
                                            }, `商品编码: ${item.productNo || ''}`),
                                            h('span', {
                                                style: {
                                                    color: '#ff9900',
                                                    fontWeight: 'bold',
                                                    marginRight: '15px'
                                                }
                                            }, `产品内码: ${item.productId}`),
                                            item.productSku ? h('span', {
                                                style: {
                                                    color: '#2d8cf0'
                                                }
                                            }, `SKU: ${item.productSku}`) : null
                                        ]),
                                        h('div', {
                                            style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexWrap: 'wrap'
                                            }
                                        }, [
                                            h('span', {
                                                style: {
                                                    marginRight: '15px',
                                                    color: '#19be6b',
                                                    fontWeight: 'bold'
                                                }
                                            }, `数量: ${item.count}`),
                                            h('span', {
                                                style: {
                                                    color: isComplete ? '#19be6b' : '#ed4014',
                                                    fontWeight: 'bold',
                                                    marginRight: '15px'
                                                }
                                            }, `已扫: ${scanned}/${item.count}`),
                                            item.shelfPosition ? h('span', {
                                                style: {
                                                    color: '#2d8cf0'
                                                }
                                            }, `货架: ${item.shelfPosition}`) : null
                                        ])
                                    ])
                                ]);
                            }))
                        ]);
                    }
                },
                {
                    title: '状态',
                    width: 100,
                    render: (h: any, params: any) => {
                        let statusText = '';
                        let statusColor = '';

                        if (params.row.packageStatus === 4) {
                            statusText = '已出仓';
                            statusColor = 'success';
                        } else if (this.isOrderComplete(params.row)) {
                            statusText = '可打包';
                            statusColor = 'warning';
                        } else {
                            const status = Enums.WarehouseOrderPackageStatus.find((item: any) => item.value === params.row.packageStatus);
                            statusText = status ? status.name : '未知';
                            statusColor = 'default';
                        }

                        return h('Tag', {
                            props: {
                                color: statusColor
                            }
                        }, statusText);
                    }
                },
                {
                    title: '打包时间',
                    key: 'packedTime',
                    width: 160,
                    render: (h: any, params: any) => {
                        return h('span', params.row.packedTime ? moment(params.row.packedTime).format('YYYY-MM-DD HH:mm:ss') : '-');
                    }
                },
                {
                    title: '操作',
                    width: 220,
                    fixed: 'right',
                    render: (h: any, params: any) => {
                        const isPacked = (params.row.packageStatus === 4 || params.row.packageStatus === 2);
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                    disabled: false
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.printOrderPdf(params.row);
                                    }
                                }
                            }, '打印面单'),
                            h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small',
                                    disabled: false
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.viewOrderPdf(params.row);
                                    }
                                }
                            }, '浏览面单'),
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small',
                                    disabled: isPacked || !this.isOrderComplete(params.row)
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.completeOrderPack(params.row);
                                    }
                                }
                            }, '完成打包'),
                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                    disabled: isPacked
                                },
                                on: {
                                    click: () => {
                                        this.markOrderAbnormal(params.row);
                                    }
                                }
                            }, '标记异常')
                        ]);
                    }
                }
            ];
        }

        viewOrderPdf(order: any) {
            const pdfData = this.getPdfUrl(order);
            if (pdfData.url) {
                window.open(pdfData.url, '_blank');
            } else {
                this.$Message.error('无法获取面单链接');
            }
        }

        async created() {
            this.batchNumber = this.$route.params.batchName as string || '';
            await this.loadPrinterList();
            if (this.batchNumber) {
                await this.getOrderList();
                this.focusScanInput();
            } else {
                this.focusScanOrderInput();
            }
        }

        @Watch('$route.params.batchName')
        async onBatchNumberChange(newVal: string) {
            if (newVal && this.$store.state.backPackingBatch.isRedirect) {
                this.$store.state.backPackingBatch.isRedirect = false;
                this.batchNumber = newVal;
                this.scanRecords = [];
                this.currentOrder = null;
                await this.getOrderList();
                this.focusScanInput();
            }
        }

        async searchBatch() {
            if (!this.batchNumber || !this.batchNumber.trim()) {
                this.$Message.warning('请输入批次号');
                return;
            }

            if (!this.isLoadPrintList) {
                await this.loadPrinterList();
            }

            // 2. 加载完了，但没选打印机 → 提示
            if (!this.selectedPrinter) {
                this.$Modal.warning({
                    title: '提示',
                    content: '请先选择打印机',
                    okText: '确定'
                });
                return;
            }

            this.scanRecords = [];
            this.currentOrder = null;
            this.orderList = [];
            this.totalCount = 0;
            this.packedCount = 0;
            this.unpackedCount = 0;

            this.$router.replace({
                name: 'backstockorderbatchpackbybox',
                params: {
                    batchName: this.batchNumber.trim()
                }
            });

            await this.getOrderList();
            this.focusScanInput();
        }

        async getOrderList() {
            this.loading = true;
            try {
                const result = await this.$store.dispatch('backStockOrderBatch/getBatchStockOrderList', {
                    data: {
                        batchName: this.batchNumber,
                        isBox: true
                    }
                });

                // ========== 测试用：强制所有订单为未打包状态 ==========
                //let orderListData = (result || []).map(order => ({
                //    ...order,
                //    packageStatus: 0,  // 强制设为未打包
                //    packedTime: null   // 清空打包时间
                //}));
                // ================================================

                // 先修改状态，再排序
                this.orderList = (result || []).sort((a: any, b: any) => {
                    if (a.packedTime && !b.packedTime) return -1;
                    if (!a.packedTime && b.packedTime) return 1;
                    if (a.packedTime && b.packedTime) {
                        return new Date(b.packedTime).getTime() - new Date(a.packedTime).getTime();
                    }
                    // 未打包的按箱号升序
                    if (!a.packedTime && !b.packedTime) {
                        return (a.sort || 0) - (b.sort || 0);
                    }
                    return 0;
                });

                this.totalCount = this.orderList.length;
                this.packedCount = this.orderList.filter((o: any) => o.packageStatus === 4 || o.packageStatus === 2).length;
                this.unpackedCount = this.totalCount - this.packedCount;

                // 初始化当前订单（找到箱号最小的可打包订单）
                this.updateCurrentOrder();
            } catch (error) {
                this.$Message.error('获取订单列表失败');
            } finally {
                this.loading = false;
            }
        }

        // 更新当前订单：从可打包订单中找箱号最小的一个
        // 更新当前订单：从未打包订单中找箱号最小的一个
        updateCurrentOrder() {
            // 未打包订单：packageStatus !== 4 && packageStatus !== 2
            const unpackedOrders = this.orderList.filter(order =>
                order.packageStatus !== 4 && order.packageStatus !== 2
            );

            console.log('未打包订单数量:', unpackedOrders.length);

            if (unpackedOrders.length === 0) {
                this.currentOrder = null;
                return;
            }

            // 按箱号（sort）升序，取第一个作为当前订单
            unpackedOrders.sort((a, b) => (a.sort || 0) - (b.sort || 0));
            const targetOrder = unpackedOrders[0];

            console.log('当前订单:', targetOrder.orderNumber, '箱号:', targetOrder.sort);

            // 构建当前订单的商品信息
            const allProducts = [];
            let totalRemainingAll = 0;
            for (const product of targetOrder.productInfos || []) {
                const scanRecord = this.scanRecords.find(r => r.productId === product.productId);
                const scanned = scanRecord ? scanRecord.scanCount : 0;
                const remaining = product.count - scanned;
                allProducts.push({
                    ...product,
                    scannedCount: scanned,
                    needCount: product.count,
                    remaining: remaining,
                    isScanned: scanRecord !== undefined
                });
                totalRemainingAll += remaining;
            }

            const matchedProducts = allProducts.filter(p => p.isScanned);
            const allMatchedSatisfied = matchedProducts.length > 0 && matchedProducts.every(mp => mp.remaining === 0);

            let sortPriority = 3;
            let priorityText = '其他';
            if (allMatchedSatisfied) {
                if (totalRemainingAll === 0) {
                    sortPriority = 1;
                    priorityText = '可打包';
                } else {
                    sortPriority = 2;
                    priorityText = '当前商品已够';
                }
            } else {
                sortPriority = 3;
                priorityText = '当前商品未够';
            }

            this.currentOrder = {
                orderId: targetOrder.id,
                orderNumber: targetOrder.orderNumber,
                sort: targetOrder.sort,
                products: allProducts,
                sameProductCount: matchedProducts.length,
                totalProductCount: targetOrder.productInfos.length || 0,
                remainingCount: matchedProducts.reduce((sum, mp) => sum + mp.remaining, 0),
                totalRemainingAll: totalRemainingAll,
                currentProductNeedCount: matchedProducts.length > 0 ? matchedProducts[0].needCount : 0,
                currentProductScannedCount: matchedProducts.length > 0 ? matchedProducts[0].scannedCount : 0,
                sortPriority: sortPriority,
                priorityText: priorityText
            };
        }

        getProductScannedCount(productId: number): number {
            const record = this.scanRecords.find(r => r.productId === productId);
            return record ? record.scanCount : 0;
        }

        async handleScan() {

            if (this.scanLock) {
                this.scanBarcode = '';
                this.focusScanInput();
                return;
            }
            this.scanLock = true; // 上锁
            try {
                if (!this.scanBarcode) return;


                this.scanBarcode = this.scanBarcode.trim().toUpperCase();
                const now = Date.now();

                // 核心逻辑：必须先检查当前是否有正在打包的订单
                if (!this.currentOrder) {
                    this.$Message.error('当前没有未打包的订单');
                    this.scanBarcode = '';
                    this.focusScanInput();
                    return;
                }


                // 在当前订单中查找该商品
                const productInCurrentOrder = this.currentOrder.products.find(p => p.productNo === this.scanBarcode);
                if (!productInCurrentOrder) {
                    this.$Message.error(`商品编码错误：当前订单 ${this.currentOrder.orderNumber} (箱号:${this.currentOrder.sort}) 不需要此商品，请扫描该订单所需商品`);
                    this.scanBarcode = '';
                    this.focusScanInput();
                    return;
                }
                //BatchId

                // 2秒内重复有效扫描 → 直接拦截
                if (this.scanBarcode === this.lastScanBarcode && now - this.lastScanTime < 1500) {
                    await this.$store.dispatch('backStockOrderBatch/addScan', {
                        batchId: this.orderList[0].batchId,
                        productNo: this.scanBarcode,
                        isEnable: false
                    });

                    this.scanBarcode = '';
                    this.focusScanInput();
                    return;
                } else {
                    this.lastScanBarcode = this.scanBarcode;
                    this.lastScanTime = now;
                    await this.$store.dispatch('backStockOrderBatch/addScan', {
                        batchId: this.orderList[0].batchId,
                        productNo: this.scanBarcode,
                        isEnable: true
                    });
                }

                // 如果商品存在但已扫够数量，提示不可再扫
                const currentScanned = this.getProductScannedCount(productInCurrentOrder.productId);
                if (currentScanned >= productInCurrentOrder.needCount) {
                    this.$Message.warning(`商品 ${productInCurrentOrder.productNo} 已扫够数量，无需再扫`);
                    this.scanBarcode = '';
                    this.focusScanInput();
                    return;
                }

                // 1. 更新扫描记录
                const existingRecord = this.scanRecords.find(r => r.productId === productInCurrentOrder.productId);
                if (existingRecord) {
                    existingRecord.scanCount += 1;
                    existingRecord.lastScanTime = new Date().toISOString();
                } else {
                    this.scanRecords.push({
                        id: `scan_${Date.now()}_${Math.random()}`,
                        productId: productInCurrentOrder.productId,
                        productNo: productInCurrentOrder.productNo,
                        productSku: productInCurrentOrder.productSku,
                        productName: productInCurrentOrder.productName,
                        productImgGuid: productInCurrentOrder.productImgGuid,
                        scanCount: 1,
                        lastScanTime: new Date().toISOString()
                    });
                }

                // 2. 检查当前订单是否已凑齐
                const isCurrentComplete = this.isOrderComplete(this.currentOrder);
                if (isCurrentComplete) {
                    // 获取完整订单对象
                    const fullOrder = this.orderList.find(o => o.id === this.currentOrder.orderId);
                    if (fullOrder) {
                        // 直接打包，不弹窗
                        await this.completeOrderPack(fullOrder);
                    }
                } else {
                    this.$Message.success(`扫描成功，当前订单 ${this.currentOrder.orderNumber} 还需扫描其他商品`);
                    // 刷新当前订单显示（因为扫描记录变了）
                    this.updateCurrentOrder();
                }

                this.scanBarcode = '';
                this.focusScanInput();
            } finally {
                this.scanLock = false;
            }
        }

        isOrderComplete(orderOrCurrent: any): boolean {
            let productInfos = orderOrCurrent.productInfos;
            if (!productInfos && orderOrCurrent.products) {
                productInfos = orderOrCurrent.products;
            }
            if (!productInfos) return false;
            for (const product of productInfos) {
                const scanned = this.getProductScannedCount(product.productId);
                if (scanned < (product.count || product.needCount)) {
                    return false;
                }
            }
            return true;
        }

        updateScanCount(record: ScanRecord, newCount: number) {
            if (newCount <= 0) {
                this.deleteScanRecord(record);
                return;
            }

            const index = this.scanRecords.findIndex(r => r.id === record.id);
            if (index !== -1) {
                const updatedRecord = {
                    ...record,
                    scanCount: newCount,
                    lastScanTime: new Date().toISOString()
                };
                this.scanRecords = [
                    ...this.scanRecords.slice(0, index),
                    updatedRecord,
                    ...this.scanRecords.slice(index + 1)
                ];
            }

            this.$nextTick(() => {
                this.updateCurrentOrder();
                // 检查当前订单是否已凑齐
                if (this.currentOrder && this.isOrderComplete(this.currentOrder)) {
                    const fullOrder = this.orderList.find(o => o.id === this.currentOrder.orderId);
                    if (fullOrder) {
                        // 直接打包，不弹窗
                        this.completeOrderPack(fullOrder);
                    }
                }
            });
        }

        deleteScanRecord(record: ScanRecord) {
            this.$Modal.confirm({
                title: '确认删除',
                content: '确定要删除这条扫描记录吗？',
                onOk: () => {
                    this.scanRecords = this.scanRecords.filter(r => r.id !== record.id);
                    this.updateCurrentOrder();
                }
            });
        }

        clearScanRecords() {
            this.$Modal.confirm({
                title: '确认清空',
                content: '确定要清空所有扫描记录吗？',
                onOk: () => {
                    this.scanRecords = [];
                    this.updateCurrentOrder();
                    this.$Message.success('已清空扫描记录');
                }
            });
        }


        getPdfUrlDirect(data: any): string {
            if (!this.isPdfData) {
                return appconst.remoteServiceBaseUrl + "api/File/GetPdf?guid=" + data.pdfGuid +
                    "&id=" + (data.userId ? data.userId : abp.session.userId) +
                    "&orderNumber=" + data.orderNumber;
            } else {
                const infos = this.formatShelfData(data.productInfos);
                const heightPercentage = data.tradeNo.startsWith("68") ? 100 : 69;
                return appconst.remoteServiceBaseUrl + "api/File/GetZDYPdf?guid=" + data.pdfGuid +
                    "&userId=" + data.userId +
                    "&heightPercentage=" + heightPercentage +
                    "&infos=" + encodeURIComponent(infos);
            }
        }

        async completeOrderPack(order: any) {
            const totalSkuCount = order.productInfos.reduce((sum: number, item: any) => {
                return sum + (item.count || 0);
            }, 0) || 0;

            // 1. 调用打包接口
            await this.$store.dispatch({
                type: 'backstockorder/stockOrderBale',
                data: {
                    id: order.id,
                    SackNums: 0,
                    BaseSkuNums: totalSkuCount,
                    WarehouseReMark: ''
                }
            });

            // 1. 先更新订单状态（立即生效）
            order.packageStatus = 4;
            order.packedTime = new Date();

            // 2. 移除该订单相关的扫描记录
            for (const product of order.productInfos || []) {
                const record = this.scanRecords.find(r => r.productId === product.productId);
                if (record) {
                    record.scanCount -= product.count;
                    if (record.scanCount <= 0) {
                        this.scanRecords = this.scanRecords.filter(r => r.id !== record.id);
                    }
                }
            }

            // 3. 立即更新统计数据
            this.packedCount = this.orderList.filter((o: any) => o.packageStatus === 4 || o.packageStatus === 2).length;
            this.unpackedCount = this.totalCount - this.packedCount;

            // 4. 重新排序订单列表（基于更新后的状态）
            this.orderList = [...this.orderList].sort((a: any, b: any) => {
                const aPacked = (a.packageStatus === 4 || a.packageStatus === 2);
                const bPacked = (b.packageStatus === 4 || b.packageStatus === 2);
                if (aPacked && !bPacked) return -1;
                if (!aPacked && bPacked) return 1;
                if (aPacked && bPacked) {
                    return new Date(b.packedTime).getTime() - new Date(a.packedTime).getTime();
                }
                // 未打包的按箱号升序
                return (a.sort || 0) - (b.sort || 0);
            });

            // 5. 重新计算当前订单（自动切换到下一个箱号最小的可打包订单）
            this.updateCurrentOrder();

            // 6. 如果有新的当前订单，提示用户
            if (this.currentOrder) {
                this.$Message.success(`订单 ${order.orderNumber} (箱号:${order.sort}) 打包完成，当前订单切换到箱号 ${this.currentOrder.sort}`);
            } else {
                this.$Message.success(`订单 ${order.orderNumber} (箱号:${order.sort}) 打包完成，没有更多可打包订单`);
            }

            // 7. 滚动到顶部
            this.$nextTick(() => {
                const table = this.$refs.selection as any;
                if (table && table.$el) {
                    const tableBody = table.$el.querySelector('.ivu-table-body');
                    if (tableBody) tableBody.scrollTop = 0;
                }
            });

            await this.printPdf(order);
        }

        markOrderAbnormal(order: any) {
            this.currentAbnormalOrder = order;
            var updateData = new UpdatebackstockorderStatu();
            updateData.id = order.id;
            updateData.orderStatus = -1;
            updateData.reMark = order.warehouseNote;
            updateData.orderNumber = order.orderNumber;
            this.$store.state.backstockorder.updateOrdeData = updateData;
            this.updateOderStatuShow = true;
        }

        handleAbnormalSuccess() {
            this.updateOderStatuShow = false;
            if (this.currentAbnormalOrder) {
                for (const product of this.currentAbnormalOrder.productInfos || []) {
                    const record = this.scanRecords.find(r => r.productId === product.productId);
                    if (record) {
                        record.scanCount -= product.count;
                        if (record.scanCount <= 0) {
                            this.scanRecords = this.scanRecords.filter(r => r.id !== record.id);
                        }
                    }
                }
                this.updateCurrentOrder();
                this.currentAbnormalOrder = null;
            }
            this.getOrderList();
        }

        async printOrderPdf(order: any) {
            await this.printPdf(order);
        }

        currentOrderRowClassName(row: any, index: number) {
            if (row.sortPriority === 1) {
                return 'current-order-row';
            }
            return '';
        }

        focusScanInput() {
            setTimeout(() => {
                const input = this.$refs.scanInput as any;
                if (input && input.focus) {
                    input.focus();
                }
            }, 100);
        }

        focusScanOrderInput() {
            setTimeout(() => {
                const input = this.$refs.scanOrderInput as any;
                if (input && input.focus) {
                    input.focus();
                }
            }, 100);
        }

        async loadPrinterList() {
            try {
                var printWorld = new GetPrintWorld();
                var json = {
                    action: "printers",
                    refresh: true,
                    defaultprn: true,
                    error: "",
                    val: {}
                };

                printWorld.CallbackOnPrinterList((response: any) => {
                    if (response.val && response.val.length > 0) {
                        this.printerList = response.val.map((p: any) => p.name);
                    }
                    this.isLoadPrintList = true;
                });

                if (!printWorld.Act(json)) {
                    console.error('获取打印机列表失败');
                }
            } catch (error) {
                console.error('加载打印机失败', error);
            }
        }

        async printPdf(data: any): Promise<boolean> {
            if (!this.selectedPrinter) {
                this.$Modal.warning({
                    title: '提示',
                    content: '请先选择打印机',
                    okText: '确定'
                });
                return false;
            }

            try {
/*                var pdfUrl = this.getPdfUrl(data);*/
                var pdfUrl = { url: null };
                pdfUrl.url = this.getPdfUrlDirect(data);

                if (pdfUrl.url) {
                    var printWorld = new GetPrintWorld();
                    var jsons: any = {
                        action: "printfile",
                        format: "file_base64",
                        content: "",
                        printer: this.selectedPrinter,
                        paperlength: this.isPdfData ? 140 : 15,
                        paperwidth: this.isPdfData ? 100 : 10
                    };
                    const baseData = await this.pdfLinkToBase64(pdfUrl.url);
                    jsons.content = "data:application/pdf;base64," + baseData;
                    if (this.needCert) {
                        jsons.cert = "https://tkyc.ddtmx.com/cer/ddtxianluo.ctf";
                    }
                    printWorld.Act(jsons);
                    return true;
                }
                return false;
            } catch (error) {
                console.error('打印失败', error);
                return false;
            }
        }

        getPdfUrl(data: any): any {
            var pdfData: any = {};
            pdfData.pdfGuid = data.pdfGuid;
            pdfData.userId = data.userId;
            pdfData.orderNumber = data.orderNumber;
            pdfData.pdfdata = this.isPdfData;
            if (this.isPdfData) {
                pdfData.infos = this.formatShelfData(data.productInfos);
                if (data.tradeNo && data.tradeNo.startsWith("68")) {
                    pdfData.heightPercentage = 100;
                } else {
                    pdfData.heightPercentage = 69;
                }
            }
            this.$store.commit('fontorder/getZDYPdfUrl', pdfData);
            return pdfData;
        }

        formatShelfData(data: any[]): string {
            if (!data || data.length === 0) return '';
            const totalCount = data.reduce((sum, item) => sum + item.count, 0);
            const formatTotal = (str: string) => str.padEnd(13, ' ');
            const formatShelf = (str: string) => str.padEnd(20, ' ');
            const shelfItems = data.map(item =>
                formatShelf(`${item.shelfPosition || ''}_${item.productId} * ${item.count > 1 ? `[${item.count}]` : item.count}`)
            );
            let output = [];
            if (shelfItems.length > 0) {
                let firstLine = formatTotal(`Total: ${totalCount}`);
                if (shelfItems.length >= 1) firstLine += shelfItems[0];
                if (shelfItems.length >= 2) firstLine += shelfItems[1];
                output.push(firstLine);
            }
            for (let i = 2; i < shelfItems.length; i += 2) {
                let line = ' '.repeat(17);
                if (shelfItems[i]) line += shelfItems[i];
                if (shelfItems[i + 1]) line += shelfItems[i + 1];
                output.push(line);
            }
            return output.join(',');
        }

        async pdfLinkToBase64(url: string): Promise<string> {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const arrayBuffer = await response.arrayBuffer();
                return this.arrayBufferToBase64(arrayBuffer);
            } catch (error) {
                console.error('Error fetching the PDF:', error);
                throw error;
            }
        }

        arrayBufferToBase64(buffer: ArrayBuffer): string {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }
    }
